<template>
  <div id="app" class="Information2">
    <div class="content-top" style="display: flex">
      <div><img src="../assets/image/position.png" alt="" /></div>
      <div style="margin-left: 15px">所在位置 :</div>
      <div style="margin-left: 5px">{{ title }}</div>
    </div>
    <div class="content">
      <div
        :class="item.content_type === 0|| item.content_type === 2 ? 'message' : 'message pdf'"
        v-for="(item, idx) in list"
        :key="idx"
      >
        <div
          style="display: contents"
          v-if="item.content_type === 0 || item.content_type === 2"
          @click="getInfo(item)"
        >
          <!-- 小竖条 -->
          <div class="message-left"></div>
          <!-- 内容 -->
          <div class="message-content left">
            <div class="title">{{ item.name }}</div>
          </div>
          <!-- 日期 -->
          <div class="message-right right">
            <!-- <img src="../assets/image/组 2575.png" alt="" /> -->
            <div class="time">{{ item.ctime }}</div>
          </div>
        </div>
        <div
          class="pdf"
          style="display: contents"
          v-else
          @click="getInfo(item)"
        >
          <!-- pdf -->
          <div class="message-left">
            <img src="../assets/image/pdf.png" alt="" />
          </div>
          <!-- 内容 -->
          <div class="message-content left">
            <div class="title">{{ item.name }}</div>
          </div>
          <!-- 日期 -->
          <div class="message-right right">
            <!-- <img src="../assets/image/position.png" alt="" /> -->
            <div class="time">下载</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      // required: true,
      default: "",
    },
    list: {
      type: Array,
      // required: true,
      default: [],
    },
  },
  methods: {
    getInfo(item) {
      if (item.content_type === 1) {
        window.open(this.imgUrl(item.content), "_blank");
        return;
      }else  if (item.content_type === 2) {
        window.open(item.rediect_url, "_blank");
        return;
      }
      this.$router.push(`/datails?id=${item.id}`);
    },
  },
};
</script>
<style>
.content-right2 p {
  @media (max-width: 800px) {
    font-size: 14px;
  }
}
</style>
<style lang="scss" scoped>
.Information2 {
  // width: 100%;
  height: auto;
  // margin: 61px 0 0 65px;
  @media (max-width: 800px) {
    height: auto;
    margin: 0 auto;
    width: 85%;
  }
  .content-top {
    font-family: Microsoft YaHei, Microsoft YaHei !important;
    font-weight: 400;
    font-size: 16px !important;
    color: #918b9e !important;
    line-height: 21px;
    @media (max-width: 800px) {
      font-size: 14px !important;
    }
    img {
      width: 20px;
      height: 22px;
    }
  }
  .content-top div:nth-child(1) {
    img {
      width: 20px;
      height: 22px;
    }
  }
  // .content div:first-child {
  //   margin-top: 30px;
  // }
  .content {
    max-width: 1000px;
    width: 100%;
    margin-top: 50px;
    margin-left: 22px;
    @media (max-width: 1600px) {
      max-width: 880px;
      margin-left: 0;
    }
    @media (max-width: 800px) {
      margin-top: 20px;
}
    .message:last-child {
      border-bottom: 0;
    }
    .message:hover {
      background-color: #ecf5ff;
    }
    .message {
      cursor: pointer;
      // position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      height: 60px;
      justify-content: space-between;
      border-bottom: 1px dashed rgba(153, 153, 153, 0.5);
      background-color: #fff;
      transition: background-color 0.5s ease;

      .message-left {
        height: 60px;
        line-height: 60px;
        float: left;
        width: 3px;
        height: 18px;
        background: #ec4546;
        margin: 0 16px 0 0;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #ec4546;
        .message-img-none {
          display: none;
        }
      }
      .message-content {
        width: calc(100% - 116px);
        // @media (max-width: 1000px) {
        //   width: 76%;
        // }
        @media (max-width: 800px) {
       width: calc(100% - 116px);
        }
        @media (max-width: 300px) {
          width: 50%;
        }
        // align-items: center;
        .title {
          width: auto;
          height: 60px;
          line-height: 60px;
          margin: 0 !important;
          font-family: Microsoft YaHei, Microsoft YaHei !important;
          font-weight: 400;
          font-size: 16px;
          color: #5d5d5d;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          @media (max-width: 800px) {
            font-size: 14px;
          }
          @media (max-width: 300px) {
            font-size: 12px;
          }
        }
      }
      .message-right {
        width: 90px;
        // justify-content: end;
        // width: 100px;
        // height: 19px;
        // display: flex;
        @media (max-width: 800px) {
        width: 90px;
        }
        @media (max-width: 300px) {
        width: 90px;
        }
        img {
          width: 15px;
          height: 15px;
        }
        .time {
          height: 60px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #343434;
          line-height: 60px;
          text-align: center;
          // text-transform: none;
          margin-top: 0;
          margin-left: 7px;
          @media (max-width: 800px) {
            font-size: 14px;
          }
          @media (max-width: 300px) {
            font-size: 12px;
          }
        }
      }
      .left {
        float: left;
      }
      .right {
        float: right;
      }
    }
    .pdf {
      // cursor: pointer;
      // display: flex;
      // align-items: center;
      width: 100%;
      height: 80px;
      // border-bottom: 1px solid #999;
      .message-left {
        width: 40px;
        height: 42px;
        line-height: 80px;
        border: 0;
        img {
          width: 40px;
          height: 46px;
        }
      }
      .message-content {
      width: calc(100% - 116px);
        // align-items: center;
        .title {
          width: auto;
          height: 80px;
          line-height: 80px;
          margin: 0 !important;
          font-family: Microsoft YaHei, Microsoft YaHei !important;
          // font-weight: bold;
          font-size: 16px;
          color: #343434;
          @media (max-width: 800px) {
            font-size: 14px;
          }
        }
      }
      .message-right {
        justify-content: center;
        width: 60px;
        // height: 19px;
        display: flex;
        img {
          width: 22px;
          height: 20px;
          line-height: 80px;
          margin: auto 0;
          background: #000;
        }
        .time {
          height: 80px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 16px !important;
          color: #5d5d5d;
          // color: #e0e0e0;
          line-height: 80px;
          text-align: center;
          // font-style: normal;
          // text-transform: none;
          margin-top: 0;
          margin-left: 7px;
          @media (max-width: 800px) {
            font-size: 14px !important;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/contentInformation2.vue